import { fetchProductsByFilters } from './helpers/graphql/requests';

// bump!

// Custom element that controls the filters adjusted by user
class LegacyDisposables extends HTMLElement {
  constructor() {
    super();
    this.endpoint = "https://vapesupertore1.myshopify.com/api/2025-04/graphql.json";
    this.publicToken = "07509e17a73d6fdb640c448a8cc2372a";
    this.isLoading = true;
    
    this.querySelector('[data-brand-options]').addEventListener('click', (e) => {
      if (e.target && e.target.matches("input[type='radio']")) {
        let v = e.target.value;
        this.setAttribute('data-brand', v);
        document.querySelector('product-replacements').setAttribute('data-brand', v);
    }
    })


    this.querySelector('[data-device-options]').addEventListener('click', (e) => {
      if (e.target && e.target.matches("input[type='radio']")) {
        let v = e.target.value;
        this.setAttribute('data-device', v);
        document.querySelector('product-replacements').setAttribute('data-device', v);
    }
    })

    this.querySelector('[data-flavour-options]').addEventListener('click', (e) => {
      if (e.target && e.target.matches("input[type='radio']")) {
        let v = e.target.value;
        this.setAttribute('data-flavour', v);
        document.querySelector('product-replacements').setAttribute('data-flavour', v);
    }
    })

    this.querySelectorAll('[data-selected-control]').forEach((el) => {
      el.addEventListener('click', (e) => {

        switch (el.getAttribute('data-selected-kind')) {
          case 'brand':
            this.setAttribute('data-brand', 'default');
            this.setAttribute('data-device', 'default');

            document.querySelector('product-replacements').setAttribute('data-brand', 'default');
            document.querySelector('product-replacements').setAttribute('data-device', 'default');

            break;
        
          default:
            break;
        }


      })
    })

  }

  // watch for changes on any of the bound data values
  static get observedAttributes() {
    return ['data-brand', 'data-device', 'data-flavour'];
  }

  // when one of the values changes, hook into the lifecycle
  attributeChangedCallback(name, oldValue, newValue){
    let dataBrand = this.getAttribute("data-brand");

    if(name == 'data-brand'){
    this.filterDevicesByBrand(dataBrand);
    }
  }


  /* ============================================================================================================================ */

  // Function that shows / hides the relevant devices depending on the current selected brand

  // function -> filterDevicesByBrand
  // Runs everytime user changes the brand option

  /* ============================================================================================================================ */

  filterDevicesByBrand(b){
    if(b == "default"){

      this.clearBrand();
      this.querySelector('[data-selected-kind="brand"]').classList.add('visually-hidden');
      this.querySelector('[data-device-options]').classList.add('visually-hidden');
      this.querySelector('[data-device-blank-text]').classList.remove('visually-hidden');

      this.querySelectorAll('.device-option').forEach((i)=>{
        i.classList.remove('visually-hidden');
      })
    } else {
      this.querySelector('[data-selected-kind="brand"] .collection-quiz-form__brand-selected-item span').innerHTML = `${b}`;
      this.querySelector('[data-selected-kind="brand"]').classList.remove('visually-hidden');
      this.querySelector('[data-device-options]').classList.remove('visually-hidden');
      
      this.querySelector('[data-device-blank-text]').classList.add('visually-hidden');
      this.querySelectorAll('.device-option').forEach((c,i)=>{
        if(c.dataset.brand.includes(b) || c.dataset.brand == b){
          c.classList.remove('visually-hidden');
        } else {
          c.classList.add('visually-hidden');
        }
      })
      
    }
  }

  // Runs as when the component mounts the page for the first time
  async connectedCallback() {
    try {

      const data = await this.getProducts();

      const brands = [];
      const devices = [];

      data?.nodes.map((i) => {

        if(i?.tags.includes('Multi-Pack')) {
          return
        } else {
          brands.push(i?.vendor);
          devices.push(`${i?.vendor} | ${i?.title}`);
        }
      })

      const uniqueBrands = [...new Set(brands)];
      const uniqueDevices = [...new Set(devices)];


      let brandOptionsHtml = '';
      uniqueBrands.forEach(brand => {
        brandOptionsHtml += `<label class="radio-label brand-option">
              <input type="radio" name="brand" value="${brand}">
              <span>${brand}</span>
            </label>`;
      });


      let deviceOptionsHtml = '';
      uniqueDevices.forEach(device => {

        let n = device.split('|').pop();
        let b = device.split('|').shift();

        deviceOptionsHtml += `<label class="radio-label device-option" data-brand="${b.trim()}">
              <input type="radio" name="brand" value="${n}">
              <span>${n}</span>
            </label>`;
      });

      this.querySelector('[data-brand-options]').innerHTML = `${brandOptionsHtml}`;
      this.querySelector('[data-device-options]').innerHTML = `${deviceOptionsHtml}`;


    } catch (error) {
      console.error(`An error occured getting legacy disposable products: ${error}`)
    }

  }


  /* ============================================================================================================================ */

  // Function that gets all the products in the legacy disposable collection

  // function -> getProducts (async)
  // Returns all the info we need to display dynamic options the user can use as 'filters'

  /* ============================================================================================================================ */

  async getProducts() {
    const query = `
      query {
        collection(id: "gid://shopify/Collection/260618289212") {
          title
          products(first: 100) {
            nodes {
              id
              title
              handle
              tags
              productType
              vendor
            }
          }
        }
      }
    `;

    const response = await fetch(this.endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.publicToken,
      },
      body: JSON.stringify({
        query
      }),
    });

    const json = await response.json();
    return json?.data?.collection?.products;
  }


  /* ============================================================================================================================ */

  // Function that removes the active brand

  // function -> clearBrand
  // This also reverts the recommended products to the default view

  /* ============================================================================================================================ */

  clearBrand() {
    this.querySelector('[data-brand-options]').querySelectorAll('input').forEach((el) => {
      if(el.type == "radio") {
        el.checked = false;
      }
    })

    this.querySelector('[data-device-options]').querySelectorAll('input').forEach((el) => {
      if(el.type == "radio") {
        el.checked = false;
      }
    })
  }


   /* ============================================================================================================================ */

  // Function that removes the active device

  // function -> clearDevice

  /* ============================================================================================================================ */

  clearDevice() {
    this.querySelector('[data-device-options]').querySelectorAll('input').forEach((el) => {
      if(el.type == "radio") {
        el.checked = false;
      }
    })
  }


}

customElements.define("legacy-disposables", LegacyDisposables);


// Custom el that renders the recommended products by users filters
class ProductReplacements extends HTMLElement {
  constructor() {
    super();
    this.endpoint = "https://vapesupertore1.myshopify.com/api/2025-04/graphql.json";
    this.publicToken = "07509e17a73d6fdb640c448a8cc2372a";
  }

  // watch for changes on any of the bound data values
  static get observedAttributes() {
    return ['data-brand', 'data-device', 'data-flavour'];
  }

  // when one of the values changes, hook into the lifecycle
  attributeChangedCallback(name, oldValue, newValue){
    let dataDevice = this.getAttribute("data-device");

    if(name == 'data-device'){
    this.runFilters();
    }

    if(name == 'data-flavour') {
      this.runFlavoursFilter();
    }
  }



  /* ============================================================================================================================ */

  // Reorders an array of products if they have specific ordering tags

  // function -> sortByPositionTag
  // Runs every time new products are returned from GQL

  /* ============================================================================================================================ */

  sortByPositionTag(products) {
    const maxIndex = products.length;
    const sorted = Array(maxIndex).fill(null);
    const unordered = [];
  
    for (const product of products) {
      const posTag = product.tags.find(tag => tag.startsWith('pos:'));
      if (posTag) {
        const position = Number(posTag.slice(4));
        if (!isNaN(position) && position >= 0 && position < maxIndex) {
          sorted[position] = product;
          continue;
        }
      }
      unordered.push(product); 
    }
  
    const result = sorted.map(item => {
      if (item !== null) return item;
      return unordered.shift(); 
    });
  
    return [...result, ...unordered];
  }


  /* ============================================================================================================================ */

  // Hook that runs everytime a filter has changed

  // function -> runFilters (async)
  // Runs when user selects their device or flavour preference

  /* ============================================================================================================================ */

  async runFilters() {
    try {

      this.setAttribute('data-loading', 'true');
      this.loading = true;
      this.setLoadingState('#dispoables-alternative-refillable-kits', true);
      this.setLoadingState('#dispoables-alternative-pods-kits', true);


      // keep original structures
      const refillableKitsOriginal = this.querySelector('#dispoables-alternative-refillable-kits').innerHTML;
      const podsOriginal = this.querySelector('#dispoables-alternative-pods-kits').innerHTML;
      const eliquidOriginal = this.querySelector('#dispoables-alternative-eliquids').innerHTML;

      let brand = this.getAttribute('data-brand');
      let device = this.getAttribute('data-device');

      await this.injectResponse.call(this, brand, device, refillableKitsOriginal);

      this.loading = false;
   
    } catch (error) {
      console.error(`An error occured returning alternativce products: ${error}`)
    } finally {
      this.setAttribute('data-loading', 'false');
      this.loading = false;
    }

  }



    /* ============================================================================================================================ */

  // Hook that runs everytime a flavour filter has changed

  // function -> runFlavoursFilter (async)
  // Runs when user selects their device or flavour preference

  /* ============================================================================================================================ */

  async runFlavoursFilter() {
    try {

      this.setAttribute('data-loading', 'true');
      this.loading = true;
      this.setLoadingState('#dispoables-alternative-eliquids', true);


      // keep original structures
      const eliquidOriginal = this.querySelector('#dispoables-alternative-eliquids').innerHTML;

      let flavour = this.getAttribute('data-flavour');

      await this.injectFlavoursResponse.call(this, flavour);

      this.loading = false;
   
    } catch (error) {
      console.error(`An error occured returning alternativce flavours: ${error}`)
    } finally {
      this.setAttribute('data-loading', 'false');
      this.loading = false;
    }

  }

  /* ============================================================================================================================ */

  // Function that returns filtered products

  // function -> getReplacementsBasedOnFilters (async)
  // Runs when user selects their device or flavour preference
  // Returns object

  /* ============================================================================================================================ */

  async getReplacementsBasedOnFilters(brand, device, flavour) {

    if(brand == null && device == null) {

      let f = flavour.trim();
      const cleanedFlavour = `Flavour:${f}`.replace(/\s+/g, ' ').trim();
  
      const eliquidVariables = {
        first: 10,
        query: `tag:"Disposable Bar Flavour" AND tag:"${cleanedFlavour}" product_type:"E-Liquids" sortKey:"BEST_SELLING"`
      };
  
      const eliquidsList = await fetchProductsByFilters({
        endpoint: this.endpoint,
        token: this.publicToken,
        variables: eliquidVariables
      });
  
      return {
        eliquids: eliquidsList
      };


    } else {


      let d = device.trim();
      const cleanedDevice = `Switch:${d}`.replace(/\s+/g, ' ').trim();

  
      const refillableKitVariables = {
        first: 10,
        query: `(product_type:"Vape Kits" AND tag:"Refillable" AND tag:"${cleanedDevice}" AND tag_not:"Closed Pod") OR (product_type:"Bundle Kit" AND tag:"Refillable" AND tag:"${cleanedDevice}" AND tag_not:"Closed Pod" sortKey:BEST_SELLING)`
      };
  
      const prefilledPodVariables = {
        first: 10,
        query: `(product_type:"Vape Kits" AND tag:"Closed Pod" AND tag:"${cleanedDevice}" AND tag_not:"Refillable") OR (product_type:"Bundle Kit" AND tag:"Closed Pod" AND tag:"${cleanedDevice}" AND tag_not:"Refillable" sortKey:BEST_SELLING)`
      };
  
  
      const prefilledPodsList = await fetchProductsByFilters({
        endpoint: this.endpoint,
        token: this.publicToken,
        variables: prefilledPodVariables
      });
  
      const refillableKitsList = await fetchProductsByFilters({
        endpoint: this.endpoint,
        token: this.publicToken,
        variables: refillableKitVariables
      });


      const filteredRefillableKitsList = refillableKitsList.filter(i => i?.quantity !== 0);
      const filteredPrefilledPodsList = prefilledPodsList.filter(i => i?.quantity !== 0);

      return {
        prefilledPods: this.sortByPositionTag(filteredPrefilledPodsList),
        refillableKits: this.sortByPositionTag(filteredRefillableKitsList),
      };

    }
  }


  /* ============================================================================================================================ */

  // Function that gets defaults

  // function -> getReplacementsDefaults (async)
  // Runs when users clears all filters back to default. Also runs once for initial render
  // Returns object

  /* ============================================================================================================================ */

  async getReplacementsDefaults() {

    const refillableKitVariables = {
      first: 10,
      query: `(product_type:"Vape Kits" AND tag:"Refillable" AND tag:"Switchable" AND tag_not:"Closed Pod") OR (product_type:"Bundle Kit" AND tag:"Refillable" AND tag:"Switchable" AND tag_not:"Closed Pod" sortKey:BEST_SELLING)`
    };

    const prefilledPodVariables = {
      first: 10,
      query: `(product_type:"Vape Kits" AND tag:"Closed Pod" AND tag:"Switchable" AND tag_not:"Refillable") OR (product_type:"Bundle Kit" AND tag:"Closed Pod" AND tag:"Switchable" AND tag_not:"Refillable" sortKey:BEST_SELLING)`
    };

    const eliquidVariables = {
      first: 10,
      query: `product_type:"E-Liquids" sortKey:"BEST_SELLING"`
    };


    const prefilledPodsList = await fetchProductsByFilters({
      endpoint: this.endpoint,
      token: this.publicToken,
      variables: prefilledPodVariables
    });

    const refillableKitsList = await fetchProductsByFilters({
      endpoint: this.endpoint,
      token: this.publicToken,
      variables: refillableKitVariables
    });
    const eliquidsList = await fetchProductsByFilters({
      endpoint: this.endpoint,
      token: this.publicToken,
      variables: eliquidVariables
    });


    const filteredRefillableKitsList = refillableKitsList.filter(i => i?.quantity !== 0);
    const filteredPrefilledPodsList = prefilledPodsList.filter(i => i?.quantity !== 0);

    return {
      prefilledPods: this.sortByPositionTag(filteredPrefilledPodsList),
      refillableKits: this.sortByPositionTag(filteredRefillableKitsList),
      eliquids: this.sortByPositionTag(eliquidsList)
    };
  }



  /* ============================================================================================================================ */

  // Function that handles the GQL response and determines what to render

  // function -> injectResponse (async)
  // Runs the grouped GQL queries simultaneously and updates each sub section

  /* ============================================================================================================================ */

  async injectResponse(brand, device, refillableKitsOriginal) {
    const kitsTarget = this.querySelector('#dispoables-alternative-refillable-kits');
    const podsTarget = this.querySelector('#dispoables-alternative-pods-kits');

  
    const data = device === 'default'
      ? await this.getReplacementsDefaults()
      : await this.getReplacementsBasedOnFilters(brand, device);
  
    const kits = data?.refillableKits ?? [];
    const pods = data?.prefilledPods ?? [];

    if (device != 'default' && kits.length <= 1) {


      kitsTarget.innerHTML = `<p>No results match your filters. Please try again.</p>`;
      kitsTarget.closest('.embla').querySelectorAll('.embla__button').forEach((b) => {
        b.classList.add('visually-hidden');
      })

    } else {
      const kitsHTML = kits.map(this.buildItemCard).join('');

      kitsTarget.closest('.embla').querySelectorAll('.embla__button').forEach((b) => {
        b.classList.remove('visually-hidden');
      })

      if(device != "default") {
        this.querySelector('.filtered-category[data-kind="refillableKits"] h3 span').classList.remove('visually-hidden');
      } else {
        this.querySelector('.filtered-category[data-kind="refillableKits"] h3 span').classList.add('visually-hidden'); 
      }
      kitsTarget.innerHTML = kitsHTML.includes('undefined') ? kitsHTML.replace('undefined', '') : kitsHTML;
    }

    if (device !== 'default' && pods.length <= 1) {

      podsTarget.innerHTML = `<p>No results match your filters. Please try again.</p>`;
      podsTarget.closest('.embla').querySelectorAll('.embla__button').forEach((b) => {
        b.classList.add('visually-hidden');
      })
    } else {
      const podsHTML = pods.map(this.buildItemCard).join('');

      podsTarget.closest('.embla').querySelectorAll('.embla__button').forEach((b) => {
        b.classList.remove('visually-hidden');
      })
      
      if(device != "default") {
        this.querySelector('.filtered-category[data-kind="prefilledPods"] h3 span').classList.remove('visually-hidden');
      } else {
        this.querySelector('.filtered-category[data-kind="prefilledPods"] h3 span').classList.add('visually-hidden'); 
      }
      podsTarget.innerHTML = podsHTML.includes('undefined') ? podsHTML.replace('undefined', '') : podsHTML;
    }
 
  }


  async injectFlavoursResponse(flavour) {
    const flavoursTarget = this.querySelector('#dispoables-alternative-eliquids');

  
    const data = flavour === 'default'
      ? await this.getReplacementsDefaults()
      : await this.getReplacementsBasedOnFilters(null, null, flavour);

  
    const liquids = data?.eliquids ?? [];

    if (flavour != 'default' && liquids.length <= 1) {

      flavoursTarget.innerHTML = `<p>No results match your filters. Please try again.</p>`;
      flavoursTarget.closest('.embla').querySelectorAll('.embla__button').forEach((b) => {
        b.classList.add('visually-hidden');
      })

    } else {
      const flavoursHTML = liquids.map(this.buildItemCard).join('');

      flavoursTarget.closest('.embla').querySelectorAll('.embla__button').forEach((b) => {
        b.classList.remove('visually-hidden');
      })

      if(flavour != "default") {
        this.querySelector('.filtered-category[data-kind="flavours"] h3 span').classList.remove('visually-hidden');
      } else {
        this.querySelector('.filtered-category[data-kind="flavours"] h3 span').classList.add('visually-hidden'); 
      }
      flavoursTarget.innerHTML = flavoursHTML.includes('undefined') ? flavoursHTML.replace('undefined', '') : flavoursHTML;
    }

  }


  /* ============================================================================================================================ */

  // Function that returns the correct markup for the returned replacement products

  // function -> buildItemCard
  // Returns HTML

  /* ============================================================================================================================ */

  buildItemCard(item) {

    const collections = [];
    const id = item?.id?.split('/').pop();
    const img = item?.img;
    const handle = item?.handle;
    const title = item?.title;
    const price = item?.prices?.min;
    const profiles = item?.profiles;
    const tags = item?.tags;
    

    item?.collections.map((c) => {
      collections.push(c?.handle);
    })

    const renderProfiles = () => {
      if (profiles?.length) {
        const raw = profiles[0];
        const clean = raw.replace('Profile:', '').trim();
        return `<span class="card-product__flavours">${clean}</span>`;
      } else {
        return '';
      }
    };



    const getRelevantBadge = () => {
      let _items = window?.relevantBadges?.tags;
    
          let found = false;
          let content;
  
          for (let i = 0; i < _items.length; i++) {
            if (tags.includes(_items[i].tag)) {
              found = true;
              content = _items[i].return;
              break;
            }
          }
  
          if (found) {
            return content;
          } else {
            return ``;
          }
      
  
    };

    const getMultibuyOffer = () => {
      let _items = window?.multibuyOffer?.tags;
     
          let found = false;
          let content;
  
          for (let i = 0; i < _items.length; i++) {
            if (tags.includes(_items[i].tag)) {
              found = true;
              content = _items[i].return;
              break;
            }
          }
  
          if (found) {
            return content;
          } else {
            return ``;
          }
        
      
    };


    const isNew = () => {
      let all = collections.toString();
      if (all.includes("new")) {
        return `<div class="card-product__badge card-product__newHighlight">New in</div>`;
      } else {
        return ``;
      }
    };
  
    const isSale = () => {
      let all = collections.toString();
      if (all.includes("sale")) {
        return `<div class="card-product__badge card-product__saleHighlight">Sale</div>`;
      } else {
        return ``;
      }
    };

    if(handle == undefined) {
      return;

    } else {
      return `
      <a id="Swiper-template--17835258839100__collection_quiz_banner_${id}" 
         class="card-product card-carousel-js embla__slide card--visible embla__slide--active" 
         href="/products/${handle}">
        <img src="${img}&amp;width=270" alt="${title}" width="270" height="270" loading="eager" class="card-product__image">
        ${getRelevantBadge()}
        ${isNew()}
        ${isSale()}
        ${getMultibuyOffer()}
        <h4 class="card-product__heading">${title}</h4>
        <span class="card-product__price"><span class="money">£${price}</span></span>
        ${renderProfiles()}
      </a>
    `;
    }

  

  }



  /* ============================================================================================================================ */

  // Function that returns the correct loading skeleton 

  // function ->  setLoadingState
  // Runs between every GQL request and once initially
  // Returns HTML

  /* ============================================================================================================================ */

  setLoadingState(containerSelector, isLoading) {
    const container = this.querySelector(containerSelector);
    if (!container) return;
  
    if (isLoading) {
      container.innerHTML = `
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>
        <div class="card-product card-carousel-js embla__slide card--visible embla__slide--active loading-skeleton"></div>

      `;
    }
  }
  

}

customElements.define("product-replacements", ProductReplacements);
